import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function d({ size: l = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.8333 39.336C35.8333 39.4253 35.9079 39.5 35.9973 39.5H39.3359C39.4253 39.5 39.4999 39.4253 39.4999 39.336V24.664C39.4999 24.5747 39.4253 24.5 39.3359 24.5H35.9973C35.9079 24.5 35.8333 24.5747 35.8333 24.664V39.336Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.9441 39.3934C22.9441 39.4521 22.9921 39.5001 23.0508 39.5001H26.5041C26.5628 39.5001 26.6108 39.4521 26.6108 39.3934V27.2734C26.6108 27.2147 26.5628 27.1667 26.5041 27.1667H23.0508C22.9921 27.1667 22.9441 27.2147 22.9441 27.2734V39.3934Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M38 19.5C37.1733 19.5 36.5 18.8267 36.5 18C36.5 17.1733 37.1733 16.5 38 16.5C38.8267 16.5 39.5 17.1733 39.5 18C39.5 18.8267 38.8267 19.5 38 19.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.5417 39.4996L16.5004 29.8769L20.123 29.8342L20.1657 39.4582L20.123 39.4996H16.5417Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.3892 31.1747L29.3972 39.5001H33.0478L33.0558 39.4921L33.0478 31.1667L29.3892 31.1747Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.8334 23.3333C29.8334 24.1599 30.5067 24.8333 31.3334 24.8333C32.16 24.8333 32.8334 24.1599 32.8334 23.3333C32.8334 22.5066 32.16 21.8333 31.3334 21.8333C30.5067 21.8333 29.8334 22.5066 29.8334 23.3333Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M24.6666 20.8333C23.84 20.8333 23.1666 20.1599 23.1666 19.3333C23.1666 18.5066 23.84 17.8333 24.6666 17.8333C25.4933 17.8333 26.1666 18.5066 26.1666 19.3333C26.1666 20.1599 25.4933 20.8333 24.6666 20.8333Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.5 24.6667C16.5 25.4934 17.1733 26.1667 18 26.1667C18.8267 26.1667 19.5 25.4934 19.5 24.6667C19.5 23.8401 18.8267 23.1667 18 23.1667C17.1733 23.1667 16.5 23.8401 16.5 24.6667Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38 16C36.896 16 36 16.896 36 18C36 18.292 36.0627 18.5695 36.1753 18.8196L32.5332 21.7333C32.1989 21.4821 31.7834 21.3333 31.3334 21.3333C30.807 21.3333 30.328 21.5369 29.9707 21.8697L26.6265 19.7334C26.6528 19.6041 26.6666 19.4703 26.6666 19.3333C26.6666 18.2293 25.7706 17.3333 24.6666 17.3333C23.5626 17.3333 22.6666 18.2293 22.6666 19.3333C22.6666 19.6037 22.7204 19.8616 22.8178 20.097L19.1855 23.0561C18.8537 22.8114 18.4436 22.6667 18 22.6667C16.896 22.6667 16 23.5627 16 24.6667C16 25.7707 16.896 26.6667 18 26.6667C19.104 26.6667 20 25.7707 20 24.6667C20 24.3685 19.9346 24.0855 19.8174 23.8312L23.4196 20.8966C23.7616 21.1698 24.1951 21.3333 24.6666 21.3333C25.2728 21.3333 25.8163 21.0631 26.1831 20.6368L29.4318 22.7121C29.3679 22.9076 29.3334 23.1164 29.3334 23.3333C29.3334 24.4373 30.2294 25.3333 31.3334 25.3333C32.4374 25.3333 33.3334 24.4373 33.3334 23.3333C33.3334 23.0414 33.2707 22.764 33.1582 22.5139L36.8005 19.6001C37.1347 19.8512 37.5501 20 38 20C39.104 20 40 19.104 40 18C40 16.896 39.104 16 38 16ZM38 17C38.5507 17 39 17.4493 39 18C39 18.5507 38.5507 19 38 19C37.4493 19 37 18.5507 37 18C37 17.4493 37.4493 17 38 17ZM31.3334 22.3333C31.884 22.3333 32.3334 22.7826 32.3334 23.3333C32.3334 23.8839 31.884 24.3333 31.3334 24.3333C30.7827 24.3333 30.3334 23.8839 30.3334 23.3333C30.3334 22.7826 30.7827 22.3333 31.3334 22.3333ZM25.6666 19.3333C25.6666 18.7826 25.2173 18.3333 24.6666 18.3333C24.116 18.3333 23.6666 18.7826 23.6666 19.3333C23.6666 19.8839 24.116 20.3333 24.6666 20.3333C25.2173 20.3333 25.6666 19.8839 25.6666 19.3333ZM19 24.6667C19 24.1161 18.5507 23.6667 18 23.6667C17.4493 23.6667 17 24.1161 17 24.6667C17 25.2174 17.4493 25.6667 18 25.6667C18.5507 25.6667 19 25.2174 19 24.6667Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.5038 26.6667H23.0505C22.7158 26.6667 22.4438 26.9387 22.4438 27.2734V39.3934C22.4438 39.7281 22.7158 40.0001 23.0505 40.0001H26.5038C26.8398 40.0001 27.1105 39.7281 27.1105 39.3934V27.2734C27.1105 26.9387 26.8398 26.6667 26.5038 26.6667ZM23.4438 39.0001H26.1105V27.6667H23.4438V39.0001Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.1238 29.3333H16.5424C16.2438 29.3333 15.9998 29.5773 15.9998 29.8759V39.4573C15.9998 39.7559 16.2438 39.9999 16.5424 39.9999H20.1238C20.4238 39.9999 20.6664 39.7559 20.6664 39.4573V29.8759C20.6664 29.5773 20.4238 29.3333 20.1238 29.3333ZM16.9998 38.9999H19.6664V30.3333H16.9998V38.9999Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.3975 30.6667H33.0482C33.3282 30.6667 33.5562 30.8947 33.5562 31.1747V39.4921C33.5562 39.7721 33.3282 40.0001 33.0482 40.0001H29.3975C29.1162 40.0001 28.8895 39.7721 28.8895 39.4921V31.1747C28.8895 30.8947 29.1162 30.6667 29.3975 30.6667ZM32.5562 39.0001H29.8895V31.6667H32.5562V39.0001Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.9973 24H39.3359C39.7013 24 39.9999 24.2987 39.9999 24.664V39.336C39.9999 39.7013 39.7013 40 39.3359 40H35.9973C35.6319 40 35.3333 39.7013 35.3333 39.336V24.664C35.3333 24.2987 35.6319 24 35.9973 24ZM38.9999 39H36.3333V25H38.9999V39Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
d.__tags = [];
export {
  d as MetricExpansionRateIcon
};
//# sourceMappingURL=index.es406.js.map
